/**
 * このファイルの目的
 * 組織が保持する全ての商品情報について、DBへのアクセスを隠蔽して、UIロジック層が使いやすい形で保持・提供する
 *
 *
 * やるべきこと
 * UIロジックに対して、商品オブジェクトの一覧を返したり、指定された商品オブジェクトを返したり、書き込み（更新）要求を受け付けてDBに登録する機能を提供する
 * DB(cacheManage)からorganizationTableのデータを取得して、商品情報だけを分離して、一つ一つの商品をオブジェクトにする
 * 個別の商品オブジェクトが更新するときに、必要最小限のDBレコードを更新登録する
 */

import { OrganizationDataManage } from '@/businessRepository/organizationTable/organizationDataManage';
import { createItemId } from '@/businessRepository/idUtils';
import { IOrganizationRecordHeader } from '@/coreDomainsModule/entities/record';
import { IItem } from '@/appLogic/interfaces/item';

const _prepareItem = (entry: IItem): (IItem | IOrganizationRecordHeader) | (IItem | IOrganizationRecordHeader)[] => {
  if (!entry.itemId) entry.itemId = createItemId(); // itemIdが設定されていない情報の場合は新規登録になるので新しいitemIdを生成する
  return { organizationId: '', dataId: entry.itemId, dataType: 'item', ...entry };
};

let itemManager: OrganizationDataManage<IItem>;

/**
 *
 */
const getItemManager = () => {
  if (!itemManager) itemManager = new OrganizationDataManage<IItem>('itemId', _prepareItem);
  return itemManager;
};

export { getItemManager };
